const getLanguage = () => {
    const locationPath = location.pathname.replace('/pages/latest', '').split('/');
    const country = locationPath[1];
    const lang = locationPath[2];
    return {
        country,
        lang
    }
}

export default getLanguage